export default __webpack_public_path__ + "static/real-time-data-updates-9fda4121eed5dd28f7b48d492eba338b.png";